import { inject, InjectionToken } from '@angular/core';
import { EnvironmentService, SessionService } from '@galaxy/core';
import { ReportingConfig } from '@galaxy/reports/static';
import { map } from 'rxjs/operators';
import { AppConfigService } from '../app-config.service';

export const PARTNER_CENTER_REPORTING_CONFIG_TOKEN = new InjectionToken<ReportingConfig>(
  '[partner-center-client] token for looker-report config',
  {
    providedIn: 'root',
    factory: () => {
      const environmentService = inject(EnvironmentService);
      return {
        partnerId$: inject(AppConfigService).config$.pipe(map((config) => config.partnerId)),
        getEnvironment: () => environmentService.getEnvironment(),
        sessionId$: inject(SessionService).getSessionId(),
        userId$: inject(AppConfigService).config$.pipe(map((config) => config.unifiedUserId)),
        reportsUrl: `/reports`,
      };
    },
  },
);
